// extracted by mini-css-extract-plugin
export default {"page":"gV-z","cartModal":"hV-z","checkout":"iV-z","placeholder":"jV-z","account":"kV-z"};